export default "__VITE_ASSET__C6bHYU5B__"